export default "__VITE_ASSET__e1c4c06b__"